import { render, staticRenderFns } from "./UIPagination.vue?vue&type=template&id=046d2db6&scoped=true&"
import script from "./UIPagination.vue?vue&type=script&lang=js&"
export * from "./UIPagination.vue?vue&type=script&lang=js&"
import style0 from "./UIPagination.vue?vue&type=style&index=0&id=046d2db6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d2db6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VIcon,VSelect})
